import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  GET_COMBO_CUA_HANG,
  CHUYEN_CUA_HANG,
  THONG_TIN_CUA_HANG_HIEN_TAI,
} from "actions/QuanLyCuaHang/actionTypes";
import {
  getComboCuaHangSuccess,
  getComboCuaHangFailure,
  chuyenCuaHangSuccess,
  chuyenCuaHangFailure,
  thongTinCuaHangHienTaiSuccess,
  thongTinCuaHangHienTaiFailure,
} from "actions/QuanLyCuaHang";
import QuanLyCuaHangApi from "service/quanLyCuaHangApi";
import { pushNotification } from "utils/notifications";

function* getComboCuaHang(action) {
  try {
    const response = yield call(QuanLyCuaHangApi.combo, action.dataSearch);
    if (response.ok) {
      yield put(getComboCuaHangSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getComboCuaHangFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getComboCuaHangFailure());
  }
}

function* chuyenCuaHang(action) {
  try {
    const response = yield call(
      QuanLyCuaHangApi.chuyenCuaHang,
      action.dataSearch
    );
    if (response.ok) {
      yield put(chuyenCuaHangSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(chuyenCuaHangFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(chuyenCuaHangFailure());
  }
}
function* thongTinCuaHangHienTai(action) {
  try {
    const response = yield call(
      QuanLyCuaHangApi.thongTinCuaHangHienTai,
      action.dataSearch
    );
    if (response.ok) {
      yield put(thongTinCuaHangHienTaiSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(thongTinCuaHangHienTaiFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(thongTinCuaHangHienTaiFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_COMBO_CUA_HANG, getComboCuaHang);
  yield takeLatest(CHUYEN_CUA_HANG, chuyenCuaHang);
  yield takeLatest(THONG_TIN_CUA_HANG_HIEN_TAI, thongTinCuaHangHienTai);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
